export function getMessageDateFormatted(date, isConversationList = false) {
    const options = (new Date() - date) >= 86400 * 1000 ?
        (((new Date() - date) >= 86400 * 1000 * 365) ?
            { year: 'numeric', month: 'numeric', day: 'numeric' } : (isConversationList ?
                { month: 'short', day: 'numeric' } :
                { month: 'short', day: 'numeric', hour: 'numeric', minute: 'numeric' })
        ) : { hour: 'numeric', minute: 'numeric' };

    return date?.toLocaleString('en-US', options)
}